import React, { Component } from 'react';
import { Layout } from 'antd';
import { LeftMenu, RightMenu } from 'components/menu';
import MainContaienr from 'containers/main';
import DecoContainer from 'containers/deco';
import { Reports } from 'containers/modal';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import 'draft-js/dist/Draft.css';

const mapStateToProps = state => ({
	broken1: state.decos.broken1,
});

const { Sider } = Layout;
class App extends Component {
	state = {
		collapsed: true,
		broken1: true,
		broken2: false,
		wmenu: 80,
	};

	breakTwoPoint = broken => {
		this.setState({ broken2: broken });
	};

	onCollapse = collapsed => {
		let wmenu = 80;
		if (collapsed) wmenu = 200;

		this.setState({ collapsed, wmenu });
	};

	componentWillReceiveProps(nextProps) {
		const { broken1 } = nextProps;
		this.setState({ broken1 });
	}

	render() {
		const { broken1, broken2, wmenu } = this.state;
		return (
			<Layout style={{ minHeight: '100vh' }}>
				<Sider
					collapsible={false}
					collapsed={this.state.collapsed}
					onCollapse={this.onCollapse}
					style={{ minHeight: '100vh', top: '45px' }}
				>
					<div className="logo" />
					<LeftMenu />
				</Sider>
				<Layout>
					<Layout>
						<MainContaienr broken1={broken1} broken2={broken2} wmenu={wmenu} />
					</Layout>
					<Route path="/sentence/:board/decos/:type" component={DecoContainer} />
					<Sider
						width={250}
						trigger={null}
						breakpoint="lg"
						collapsedWidth="0"
						onBreakpoint={this.breakTwoPoint}
						onCollapse={(collapsed, type) => {
							//console.log(collapsed, type);
						}}
						style={{ background: '#fff' }}
					>
						<RightMenu />
					</Sider>
				</Layout>
				<Reports isReportVisible={false} />
			</Layout>
		);
	}
}

export default connect(mapStateToProps, null)(App);
